import { createContext } from "react"

import { Campaign } from "@l2r-front/l2r-proptypes"
import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

export interface CampaignStateType {
    campaignFilters: any
    hoveredCampaign: Campaign | null
    isExportRunning: IsRunning
}
type IsRunning = {
    [campaignId: string]: boolean
}
export interface CampaignDispatchType {
    setHoveredCampaign: (_hoveredCampaign: Campaign | null) => void
    setCampaignFilters: (filters: any) => void
    setIsExportRunning: (isRunning: IsRunning) => void
}

export const initialState: CampaignStateType = {
    campaignFilters: {},
    hoveredCampaign: null,
    isExportRunning: null,
}

const initialDispatch: CampaignDispatchType = {
    setHoveredCampaign: undefinedFunctionWarning("setHoveredCampaign"),
    setCampaignFilters: undefinedFunctionWarning("setCampaignFilters"),
    setIsExportRunning: undefinedFunctionWarning("setIsExportRunning"),
}

export const CampaignStateContext = createContext<CampaignStateType>(initialState)
export const CampaignDispatchContext = createContext<CampaignDispatchType>(initialDispatch)